import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import * as moment from 'moment-timezone';
import { unitOfTime } from 'moment-timezone';
import { Calendar, CalendarModule } from 'primeng/calendar';

@Component({
  standalone: true,
  selector: 'crm-daterangepicker',
  templateUrl: './daterangepicker.component.html',
  imports: [CommonModule, CalendarModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DaterangepickerComponent implements OnInit, OnDestroy {
  @ViewChild('rangepicker') public rangepicker: Calendar;
  @Output() public valueChange = new EventEmitter<Date>();
  @Input() public showButtonBar = false;
  @Input() public dateFormat = 'dd.mm.yy';
  @Input() public label: string;
  @Input() public inputId = `${Math.random()}`;
  @Input() public placeholder = '\u00A0';
  @Input() public readonlyInput = true;
  @Input() public appendTo = '';
  @Input() public isShowDay = true;
  @Input() public allowTheSameDay = true;
  @Input() public showClear = false;
  @Output() public changeValue = new EventEmitter<[Date, Date]>();
  @Output() public show = new EventEmitter<any>();
  @Output() public close = new EventEmitter<any>();

  public _value: [Date, Date];

  @Input() public isNotCheckedExternal = false;

  private timer: NodeJS.Timeout;

  @Input()
  public set value(dates: [Date | string, Date | string]) {
    if (dates[0] && dates[1]) {
      this._value = [moment(dates[0]).toDate(), moment(dates[1]).toDate()];
    } else {
      this._value = null;
    }
  }

  public get value(): [Date | string, Date | string] {
    return this._value;
  }

  public constructor(private readonly renderer2: Renderer2) {}

  public ngOnInit() {
    this.timer = setInterval(() => {
      if (this.isNotCheckedExternal) {
        (this.rangepicker?.contentViewChild?.nativeElement as HTMLElement)?.querySelectorAll('span')?.forEach((el) => {
          this.renderer2.addClass(el, 'p-datepicker-not-check-external');
        });

        const monthBtn = (this.rangepicker?.contentViewChild?.nativeElement as HTMLElement)?.querySelector(
          '.p-datepicker-month'
        );
        if (monthBtn) {
          this.renderer2.addClass(monthBtn, 'p-datepicker-not-check-external');
        }

        const yearBtn = (this.rangepicker?.contentViewChild?.nativeElement as HTMLElement)?.querySelector(
          '.p-datepicker-year'
        );
        if (yearBtn) {
          this.renderer2.addClass(yearBtn, 'p-datepicker-not-check-external');
        }
      }
    }, 300);
  }

  public ngOnDestroy() {
    clearInterval(this.timer);
  }

  public changeDate(dates: [Date, Date]) {
    if (dates?.[0] && dates?.[1]) {
      if (!this.allowTheSameDay && moment(dates[0]).isSame(dates[1])) {
        this._value = [moment(dates[0]).toDate(), moment(dates[0]).add(1, 'days').toDate()];
        this.changeValue.emit(this._value);
      } else this.changeValue.emit(dates);
    } else if (this.showClear) {
      this.changeValue.emit(null);
    }
  }

  public setPeriodDates(period: unitOfTime.DurationConstructor, previous = false) {
    const from = moment().startOf(period);
    let to = moment().endOf(period);

    if (previous) {
      from.subtract(1, period);
      to = from.clone().endOf(period);
    }

    this._value = [from.toDate(), to.toDate()];
    this.changeValue.emit(this._value);
    this.rangepicker.toggle();
  }
}
